import { TableSortItem } from "./TableSortItem";

export default TableSortItem;